import {createSlice} from '@reduxjs/toolkit';
import {baseSetValue} from "../../utils";
import {SearchResult} from "./types";

export interface SearchSliceState {
    isLoading: boolean;
    searchResults: SearchResult[],
}

const initialState: SearchSliceState = {
    isLoading: false,
    searchResults: [],
};
export const reducers = createSlice({
    name: 'search',
    initialState,
    reducers: {
        setValue: baseSetValue<SearchSliceState>()
    },
});

export const {setValue} = reducers.actions;
export default reducers.reducer;
